.categoryTabContainer {
  margin-top: 16px;
}

@media all and (--reefer-media-tablet-min) {
  .categoryTabContainer {
    margin-top: 0px;
  }
}
